import { ConnectedRouter } from 'connected-react-router';
import 'moment/locale/vi';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import './index.css';
import { setLoading } from './modules/common/redux/commonReducer';
import ConnectedIntlProvider from './modules/intl/component/ConnectedIntlProvider';
import { history, persistor, store } from './redux/configureStore';
import reportWebVitals from './reportWebVitals';
// import * as serviceWorker from './serviceWorkerRegistration';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
        onBeforeLift={() => {
          store.dispatch(setLoading(false));
        }}
      >
        <ConnectedRouter history={history}>
          <ConnectedIntlProvider>
            <App />
          </ConnectedIntlProvider>
        </ConnectedRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorker.register();
